import React from 'react';
import { motion } from 'framer-motion';
import { Award, Building2, Radio, Newspaper } from 'lucide-react';

/**
 * "Recognised by" authority strip — third-party credibility (E-E-A-T).
 * Text/icon based (no logo assets required). Items are factual references
 * only — keep in sync with what the brand can genuinely evidence.
 */
const items = [
  {
    Icon: Award,
    name: 'Dr Benny Antony, PhD',
    detail: 'Scientific Advisor · Co-developer, BCM-95®',
  },
  {
    Icon: Building2,
    name: 'Medilink Midlands',
    detail: 'UK Life Sciences Industry Association',
  },
  {
    Icon: Radio,
    name: 'BBC Radio Humberside',
    detail: 'On-air feature',
  },
  {
    Icon: Newspaper,
    name: 'Pressat',
    detail: 'UK press release distribution · Joint-health category',
  },
];

export default function RecognisedBy() {
  return (
    <section className="py-14 md:py-16 bg-stone-50 border-b border-stone-100" data-testid="recognised-by-section">
      <div className="max-w-6xl mx-auto px-6">
        <p className="text-center text-xs font-semibold tracking-[0.28em] uppercase text-slate-400 mb-8">
          Also recognised by
        </p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map(({ Icon, name, detail }, i) => (
            <motion.div
              key={name}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="flex items-start gap-3 rounded-2xl bg-white border border-stone-200 p-4"
              data-testid={`recognised-by-${i}`}
            >
              <div className="w-10 h-10 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center flex-shrink-0">
                <Icon className="w-5 h-5" strokeWidth={2} />
              </div>
              <div>
                <div className="font-bold text-[13px] md:text-sm text-slate-900 leading-tight">{name}</div>
                <div className="text-[11px] md:text-xs text-slate-500 leading-snug mt-0.5">{detail}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
